import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * AuthCallbackPage - Handles OAuth callback from Emergent Auth
 * Processes session_id from URL fragment and exchanges it for app token
 */
const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL fragment (#session_id=xxx)
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login', { 
            state: { error: 'Google giriş başarısız. Lütfen tekrar deneyin.' },
            replace: true 
          });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing Google OAuth callback...');

        // Exchange session_id for app token
        const result = await loginWithGoogle(sessionId);

        if (result.success) {
          // Clear the URL fragment and redirect to main app
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/', { replace: true });
        } else {
          navigate('/login', { 
            state: { error: result.error || 'Google giriş başarısız' },
            replace: true 
          });
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login', { 
          state: { error: 'Bir hata oluştu. Lütfen tekrar deneyin.' },
          replace: true 
        });
      }
    };

    processCallback();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-[#e8f4f8] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#1e3a5f] mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Giriş yapılıyor...</h2>
        <p className="text-gray-500">Lütfen bekleyin</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
